"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondTransferCancelRequest = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsTransfer_1 = require("../../model/hsTransfer");
var service_1 = require("../../../library/base/service");
var SecondTransferCancelRequest = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SecondTransferCancelRequest, _super);
    function SecondTransferCancelRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '取消转让接口';
        _this.code = '105012';
        _this.desc = '取消转让接口';
        _this.requestParams = new hsTransfer_1.SecondTransferCancelRequestRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SecondTransferCancelRequest;
}(service_1.BaseService));
exports.SecondTransferCancelRequest = SecondTransferCancelRequest;
//# sourceMappingURL=secondTransferCancelRequest.js.map